import GenericModel from '../../generic-model';
import { ConditionalPrice } from '../conditional-price';
import { SignStickerAsset } from './sign-sticker-asset';
import Asset from '../../asset';

export class SignStickerDetail extends GenericModel {
  archived: boolean;

  text: string;

  location: string;

  height: number;
  width: number;

  inStock: boolean;

  standard: boolean;
  textColor: string;
  foundationColor: string;
  immo: boolean;
  immoInfo: string;
  graphical: boolean;
  graphicalInfo: string;
  atelier: boolean;
  atelierInfo: string;
  installer: boolean;
  installerInfo: string;
  charge: ConditionalPrice;
  graphicsComplete: boolean;
  adminComplete: boolean;

  examples: SignStickerAsset[];

  offlineExamples: Asset[];
}
